const booksApiBaseUrl = import.meta.env.VITE_BOOKS_API_BASE_URL?.replace(/\/+$/u, "") ?? "";

export function getBookUrl(id: string) {
  return `${booksApiBaseUrl}/api/books/${encodeURIComponent(id)}`;
}
